// import

import CMS from 'decap-cms-app';
import {cmsProxyUrl, env, site} from '~/config';
import {collections} from './collections';
import cloudinaryLibrary from 'decap-cms-media-library-cloudinary';
import { createMediaLibrary } from './utils';
import { getPreSave } from './hooks';

// config

CMS.registerMediaLibrary(cloudinaryLibrary);
CMS.registerEventListener(getPreSave(), undefined);

CMS.init({
  config: {
    site_url: site.url,
    display_url: site.url,
    logo_url: undefined,

    media_folder: 'public/media',
    public_folder: 'media',
    media_folder_relative: true,
    media_library: createMediaLibrary(),
    
    slug: {
      encoding: 'ascii',
      clean_accents: true,
      sanitize_replacement: '-',
    },

    locale: 'en',
    publish_mode: 'simple',
    editor: {preview: false},
    show_preview_links: true,
    load_config_file: false,
    i18n: undefined,
    collections,

    local_backend: env.isDev ? {url: cmsProxyUrl} : undefined,
    backend: env.isDev ? {
      name: 'proxy',
      proxy_url: cmsProxyUrl,
      branch: 'staging',
    } : {
      name: 'github',
      repo: 'mikestopcontinues/msc.com',
      branch: env.isDev || env.isStaging ? 'staging' : 'master',
      base_url: site.url,
      auth_endpoint: '/api/auth/request',
      squash_merges: false,
      commit_messages: {
        create: '✍️ Create {{collection}} "{{slug}}"',
        update: '✍️ Update {{collection}} "{{slug}}"',
        delete: '✍️ Delete {{collection}} "{{slug}}"',
        uploadMedia: '✍️ Upload file "{{path}}"',
        deleteMedia: '✍️ Delete file "{{path}}"',
        openAuthoring: '✍️ Merge "{{message}}"',
      },

      // @ts-expect-error
      use_graphql: true,
    },
  }
});